export default "__VITE_ASSET__DrpgjMh5__"